import { render, staticRenderFns } from "./addLooseOrder.vue?vue&type=template&id=e4535e08&scoped=true&"
import script from "./addLooseOrder.vue?vue&type=script&lang=js&"
export * from "./addLooseOrder.vue?vue&type=script&lang=js&"
import style0 from "./addLooseOrder.vue?vue&type=style&index=0&id=e4535e08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4535e08",
  null
  
)

export default component.exports